/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {AdditionalEquipmentOptions} from "./additionalEquipmentOptions.zod";

export const HeliportMisc = zod.object({
  deIcing: zod.boolean().nullish(),
  access: zod.boolean().nullish(),
  safetyNet: zod.boolean().nullish(),
  additionalOptions: AdditionalEquipmentOptions.and(zod.unknown()).optional(),
});

export type HeliportMisc = zod.input<typeof HeliportMisc>;
export type HeliportMiscOutput = zod.output<typeof HeliportMisc>;
